import { Navigate, Route, Routes } from "react-router-dom";

import PreventiveMaintenance from "./preventiveMaintenance";
import FleetManagerAppointmentsRoutes from "./appointments/routes";
import MaintenanceMonitoring from "./maintenanceMonitoring";
import Budgets from "./budgets";
import BudgetsKanbanPage from "./budgetsKanban";
import SupportPage from "../support";
import SupportDetailsPage from "../support/pages/details";
import NewSupportCallPage from "../newSupportCall";

const FleetManagerRoutes = (props: any) => (
  <Routes>
    <Route path="/" element={<Navigate to="/fleet-manager/preventive-maintenance" />} />
    <Route path="/preventive-maintenance" element={<PreventiveMaintenance {...props} />} />
    <Route path="/maintenance-monitoring" index element={<MaintenanceMonitoring {...props} />} />
    <Route path="/appointments/*" index element={<FleetManagerAppointmentsRoutes {...props} />} />
    <Route path="/budgets/*" element={<Budgets {...props} persona="fleet-manager" />} />
    <Route path="/budgets-kanban" element={<BudgetsKanbanPage {...props} />} />
    <Route path="/support" element={<SupportPage {...props} />} />
    <Route path="/support/new-support-call" element={<NewSupportCallPage {...props} />} />
    <Route path="/support/details" element={<SupportDetailsPage {...props} />} />
  </Routes>
);

export default FleetManagerRoutes;
